import React, { useState } from 'react';
import { database } from '../../../../firebaseConfig';
import { collection, addDoc } from "firebase/firestore";
import Button from '../../../../Components/Button/Button';
import TitleText from '../../../../Components/TitleText/TitleText';
import './ContactUs.css'

const ContactUs = () => {

    const collectionRef = collection(database, "comments");

    const [data, setData] = useState({});

    const handleInput = (event) => {
        let newInput = { [event.target.name]: event.target.value };
        setData({ ...data, ...newInput });
    };

    ////////////////////////////////////////////////////////////////////
    const handleSubmit = () => {
        addDoc(collectionRef, {
            name: data.name,
            comment: data.comment,
            approved: false
        }).then(() => {

            document.getElementById('name').value = '';
            document.getElementById('comment').value = '';


            alert("thank you for your comment " + `${data.name}`)
        })


    }

    const handleKeyDown = e => {
        if (e.key === 'Enter') {
            handleSubmit()


        }
    }


    return (
        <div id="contact" className="container mt-5 ">

            <div className="row justify-content-md-center ">
                <TitleText title1="contact" title2="us" position="center" />

                <div className="col-md-12 col-sm-12 col-lg-4 mt-2 ">

                    <p className='brown'> Architecture Firm</p>
                    <p >Limit Design Ltd is an innovative architecture and interior design firm that is committed to delivering exceptional design solutions in time that exceed our client's expectations. <br /> Our focus on sustainability, functionality, and aesthetics, combined with our attention to detail has earned us a reputation as a leading firm in the industry.</p>


                </div>

                <div className="col-md-12 col-sm-12 col-lg-4 mt-2 ">
                    <p className='brown'>Contact Details</p>

                    <p><span className='brown'>Phone: </span><a className='contactInfo' href="tel:01717317707">+8801717317707</a> </p>

                    <p><span className='brown'>Mail: </span><a className='contactInfo' href="mailto:limitdesignerltd@gmail.com">limitdesignerltd@gmail.com</a></p>

                    <p><a className='contactInfo' href="https://goo.gl/maps/MdWE1XbmdEuLYK5b6"><span className='brown'>Address: </span> Ground Floor, 55/D West Dhanmondi. Dhaka- 1209</a></p>


                </div>
                <div className="col-md-12 col-sm-12 col-lg-4 mt-2 ">


                    <input
                        id="name"
                        className='form text-light'
                        name="name"
                        placeholder="Your Name"
                        onChange={(event) => handleInput(event)} /><br />

                    <input
                        id="comment"
                        className='form text-light '
                        style={{ height: "180px" }}
                        name="comment"
                        placeholder="Your Thought "
                        onKeyDown={handleKeyDown}
                        onChange={(event) => handleInput(event)} />


                    <br />
                    <Button type="submit" value="submit" onClick={(event) => handleSubmit(event)} title="SUBMIT" />


                </div>


            </div>
        </div >
    );
};

export default ContactUs;